import { cx } from '../cx.js';

/**
 * The wordmark.
 *
 * Type and one mark: three rising strokes — a call, flat, then speech, then
 * flat again — small enough to survive a favicon. Drawn in SVG with its
 * geometry in **attributes**: this bundle ships under `style-src 'self'`, so an
 * inline style would be dropped by the browser and the mark would quietly
 * collapse.
 *
 * The site once carried the same line large, as a waveform behind its
 * headings, and a coloured word in each heading (`Accent`). Both went with the
 * site's redesign (ADR-0029): a waveform is the commonest picture of "AI
 * voice", and one coloured word per heading is the commonest tell of a
 * generated page. The mark stays, where it names the product.
 */
export function Logo({
  tone = 'dark',
  className,
}: {
  /** `dark` = for a dark background. */
  readonly tone?: 'dark' | 'light';
  readonly className?: string;
}): React.JSX.Element {
  return (
    <span className={cx('inline-flex items-center gap-2', className)}>
      <svg
        viewBox="0 0 24 24"
        fill="none"
        aria-hidden="true"
        focusable="false"
        className="h-5 w-5 shrink-0"
      >
        <path
          d="M3 12h3l2.5-7 3.5 14 3-9 2 4h4"
          stroke={tone === 'dark' ? 'var(--voice-teal)' : 'var(--voice-violet)'}
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      <span
        className={cx(
          'text-ui font-bold tracking-tight',
          tone === 'dark' ? 'text-ink-light' : 'text-ink',
        )}
      >
        GSI Voice
      </span>
    </span>
  );
}
